import { render } from "./AdvertSection.vue?vue&type=template&id=48eb42be&scoped=true"
import script from "./AdvertSection.vue?vue&type=script&lang=js"
export * from "./AdvertSection.vue?vue&type=script&lang=js"

import "./AdvertSection.vue?vue&type=style&index=0&id=48eb42be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48eb42be"]])

export default __exports__